/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 修改订单取票方式
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  deliveryWay:
    | "SCENE"
    | "EXPRESS"
    | "ETICKET"
    | "SHOP"
    | "VIRTUAL"
    | "ID_CARD"
    | "WINDOW",
  orderIds: Array<string>,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/changeOrderDelivery/${deliveryWay}`,
    data: orderIds,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
